// Roles routes
export default [
  {
    path: 'roles',
    name: 'roles',
    redirect: 'roles/index',
    component: () =>
      import(/* webpackChunkName: "roles" */ '../views/roles/Roles.vue'),
    children: [
      {
        path: 'index',
        name: 'rolesManagement',
        meta: {
          tabbable: true,
          tableKeys: ['roles'],
          filterKeys: [],
          formKeys: [],
          routePermissions: ['rolesView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "rolesIndex" */ '../views/roles/RolesIndex.vue'
          ),
      },
      {
        path: ':roleName',
        name: 'rolesEdit',
        meta: {
          menuActiveRouteName: 'rolesManagement',
          routePermissions: ['rolesView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "rolesIndex" */ '../views/roles/RolesIndex.vue'
          ),
      },
    ],
  },
];
